import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="site-footer grain">
    <div className="container site-footer__inner">
      <div className="site-footer__brand">
        <span className="wordmark">
          <span className="wordmark__name">The Loft</span>
          <span className="wordmark__sub">Salon · Temecula</span>
        </span>
        <p className="site-footer__tagline">
          A warm, independent salon at Vineyard Commons. Make everyday a
          beautiful day.
        </p>
        <div className="site-footer__social">
          <a href="https://instagram.com/theloftsalontemecula" target="_blank" rel="noopener noreferrer">Instagram</a>
          <a href="https://www.facebook.com/theloftsalon" target="_blank" rel="noopener noreferrer">Facebook</a>
          <a href="https://www.yelp.com/biz/the-loft-salon-temecula-2" target="_blank" rel="noopener noreferrer">Yelp</a>
        </div>
      </div>

      <div className="site-footer__col">
        <h4 className="site-footer__heading">Visit</h4>
        <address className="site-footer__address">
          31217 Pauba Rd, Suite 202<br />
          Temecula, CA 92592<br />
          <span className="site-footer__muted">Vineyard Commons, 2nd floor, streetside</span>
        </address>
        <a
          className="link"
          href="https://maps.google.com/?q=31217+Pauba+Rd+Suite+202+Temecula+CA+92592"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get directions
        </a>
      </div>

      <div className="site-footer__col">
        <h4 className="site-footer__heading">Hours</h4>
        <p className="site-footer__hours">
          Monday – Saturday<br />
          10:00 am – 5:00 pm<br />
          <span className="site-footer__muted">Closed Sundays</span>
        </p>
      </div>

      <div className="site-footer__col">
        <h4 className="site-footer__heading">Get in touch</h4>
        <p className="site-footer__contact">
          <a href="tel:9516946016">(951) 694-6016</a><br />
          <a href="mailto:theloftsalon@tlst.us">theloftsalon@tlst.us</a>
        </p>
        <nav className="site-footer__links" aria-label="Footer">
          <Link to="/team">Find a stylist</Link>
          <Link to="/journal">Journal</Link>
          <Link to="/booths">Booth rental</Link>
          <Link to="/calendar">Booth calendar</Link>
        </nav>
      </div>
    </div>

    <div className="container site-footer__bottom">
      <p>© The Loft Salon Temecula. All rights reserved.</p>
      <p>Independent stylists · book directly with your stylist.</p>
    </div>
  </footer>
);

export default Footer;
